import { coreExtensionData, createFrontendModule } from '@backstage/frontend-plugin-api';
import nativeScaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { createFormField, FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import { NfsTemplatesRoutes } from '../../components/ScaffolderPage/TemplateList';
import { appBlueprintPickerField } from '../../scaffolder/AppBlueprintPicker/extensions';
import { azureResourceGroupPickerField } from '../../scaffolder/AzureResourceGroupPicker/extensions';
import { azureSubscriptionPickerField } from '../../scaffolder/AzureSubscriptionPicker/extensions';
import { azUserTokenField } from '../../scaffolder/AzUserToken/AzUserTokenExtension';
import { edsCheckboxGroupField } from '../../scaffolder/CheckboxGroup/extensions';
import { configurationItemPickerField } from '../../scaffolder/ConfigurationItemPicker/extensions';
import { entraGroupPickerField } from '../../scaffolder/EntraGroupPicker/extensions';
import { entraUserTokenField } from '../../scaffolder/EntraUserToken/extensions';
import { gitHubUserTokenField } from '../../scaffolder/GitHubUserToken/extensions';
import { noticeBannerField } from '../../scaffolder/NoticeBanner/extensions';
import { ownedEntityPickerField } from '../../scaffolder/OwnedEntityPicker/extensions';

// Shows our template list and filters; the native element still serves the template wizard.
const templatesSubPage = nativeScaffolderPlugin
  .getExtension('sub-page:scaffolder/templates')
  .override({
    factory: originalFactory => {
      const original = originalFactory();
      const nativeTemplatesPage = original.get(coreExtensionData.reactElement);
      return [...original].map(output =>
        output.id === coreExtensionData.reactElement.id
          ? coreExtensionData.reactElement(
              <NfsTemplatesRoutes nativeTemplatesPage={nativeTemplatesPage} />,
            )
          : output,
      );
    },
  });

export const nfsScaffolderPlugin = nativeScaffolderPlugin.withOverrides({
  extensions: [templatesSubPage],
});

// One createFormField call per field so each keeps its own value and ui:options types.
const formFields = [
  [edsCheckboxGroupField.name, createFormField(edsCheckboxGroupField)],
  [entraUserTokenField.name, createFormField(entraUserTokenField)],
  [azUserTokenField.name, createFormField(azUserTokenField)],
  [gitHubUserTokenField.name, createFormField(gitHubUserTokenField)],
  [entraGroupPickerField.name, createFormField(entraGroupPickerField)],
  [azureSubscriptionPickerField.name, createFormField(azureSubscriptionPickerField)],
  [azureResourceGroupPickerField.name, createFormField(azureResourceGroupPickerField)],
  [appBlueprintPickerField.name, createFormField(appBlueprintPickerField)],
  [ownedEntityPickerField.name, createFormField(ownedEntityPickerField)],
  [configurationItemPickerField.name, createFormField(configurationItemPickerField)],
  [noticeBannerField.name, createFormField(noticeBannerField)],
] as const;

export const scaffolderFormFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: formFields.map(([name, formField]) =>
    FormFieldBlueprint.make({ name, params: { field: async () => formField } }),
  ),
});
